import React, { useEffect } from 'react'
import HeaderComponent from '../components/HeaderComponent'

export const WorklistAttachmentsListPage = ({ instanceData }) => {

  const title = instanceData?.title || 'Purview Image'
  useEffect(() => {
    document.title = title
  }, [title])

  return <div style={{height: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column'}}>
    <HeaderComponent withLoading />
    <iframe src={`/wl/worklist/attachments/list`} 
      width={'100%'}  title={title} style={{border: '0px', margin: '0px', padding: '0px', height: '100%'}}>
    </iframe>
  </div>
}